export const STORE_CHANGED_ON_HEADER = 'storeChangedOnHeader';
export const STORE_CHANGED_ON_PAGE = 'storeChangedOnPage';
export const COMMON_STORE_LOCATION = 'commonstorelocation';

const dispatchStoreChange = (event) => {
  const newStore = JSON.parse(localStorage.getItem(COMMON_STORE_LOCATION));
  const storeChangeEvent = new CustomEvent(event, {
    detail: { newStore },
  });
  window.dispatchEvent(storeChangeEvent);
};

// notifies the listener on page of the store change on header
export const dispatchNavigationStoreChange = () => {
  dispatchStoreChange(STORE_CHANGED_ON_HEADER);
};

// notifies the listener on header of the store change on the page
export const dispatchPageStoreChange = () => {
  dispatchStoreChange(STORE_CHANGED_ON_PAGE);
};

// listener used on the header to listen to store changes from page
export const navigationStoreChangeListener = (handleStoreChange) => {
  window.addEventListener(STORE_CHANGED_ON_PAGE, handleStoreChange);
};

// listener used on the page to listen to store changes from header
export const pageStoreChangeListener = (handleStoreChange) => {
  window.addEventListener(STORE_CHANGED_ON_HEADER, handleStoreChange);
};

// consuming application needs to remove the listener
export const removeStoreChangeListener = (eventName, cb) => {
  window.removeEventListener(eventName, cb);
};

export default {
  dispatchNavigationStoreChange,
  dispatchPageStoreChange,
  navigationStoreChangeListener,
  pageStoreChangeListener,
  removeStoreChangeListener,
  STORE_CHANGED_ON_HEADER,
  STORE_CHANGED_ON_PAGE,
  COMMON_STORE_LOCATION,
};
